import { DataService } from './../../services/data.service';
import { RouteDataService } from './../../services/route-data.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { regexpPatterns } from '../../shared/patterns';
import { APP_CONFIG } from '../../app.config';
import { IAppConfig } from '../../app.config.shared';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, OnDestroy {
  pattern = regexpPatterns;
  email: string;
  securityKey: string;
  password: string;
  registerFlag = false;
  isemailReadonly = false;
  currentBrowser = '';
  partnerId: number;
  subs: Subscription[] = [];
  partnerName: string;
  partnerData: any;
  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonService: CommonService,
    private commonDataSharedService: CommonDataSharedService,
    @Inject(APP_CONFIG) private config: IAppConfig,
    private routes: ActivatedRoute,
    private router: Router,
    private _routeDataService: RouteDataService,
    private dataService: DataService
  ) {
    this.subs.push(
      this.commonDataSharedService.partnerId.subscribe((partnerId: number) => {
        this.partnerId = partnerId;
      })
    );
  }

  ngOnInit() {
    this._commonAuthService.clearLoginInfo();
    this.email = this.routes.snapshot.queryParams.email;
    this.isemailReadonly = this.routes.snapshot.queryParams.email ? true : false;
    this.securityKey = this.routes.snapshot.queryParams.activationCode;
    this.currentBrowser = this._commonService.checkCurrentBrowser();
    if (localStorage.getItem('partnerDetail')) {
      this.partnerName = JSON.parse(localStorage.getItem('partnerDetail')).partnerName;
    }

    this.subs.push(
      this.commonDataSharedService.partnerDetailData.subscribe((data: any) => {
        this.partnerData = data;
        this.partnerId = data['partnerId'];
        this.partnerName = this.partnerData.partnerName;
      })
    );
  }

  registerUser(form: NgForm) {
    if (form.value.password !== form.value.confPassword) {
      this.notificationService.show('error', `Password and confirmation doesn't match`);
      return;
    }

    const inputJson = {
      emailAddress: this.email,
      activationCode: this.securityKey,
      encryptedPassword: form.value.password,
      browser: this.currentBrowser,
      platform: navigator.platform,
      IPv4Address: null,
      partnerId: this.partnerId
    };

    this._commonRequestResponseService.postWithHeader('shared/password/set', inputJson)
      .subscribe(
        (data: any) => {
          const registerJson: any = data;
          let routingPath;
          registerJson['isLogin'] = 'true';

          this._commonAuthService.setLoginData(registerJson);
          this._routeDataService.login.next(registerJson);
          this.commonDataSharedService.loginDatas.next(registerJson.token);
          this.notificationService.show('success', 'Registered successfully');
          this.dataService.getAllStaticEntities();
          if ((registerJson.module).trim().toLowerCase() === 'student' || (registerJson.module).trim().toLowerCase() === 'parent') {
            this.registerFlag = true;
          } else {
            routingPath = '../' + (registerJson.module).trim().toLowerCase() + '/' + registerJson.route;
            this.router.navigate([routingPath], { relativeTo: this.routes });
          }
        },
        (error) => {
          this.notificationService.show('error', 'Error While Register');
        });
  }

  ngOnDestroy() {
    this.subs.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
